import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tabs, Tab } from "@material-ui/core";

import Toolbar from "../Toolbar/Toolbar";

import ChartInterface from "../ChartInterface/ChartInterface";
import HeatMapInterface from "../HeatMap/HeatMapInterface";
import { getModels } from "../../redux/slices/models";
import { loadSavedCharts } from "../../redux/slices/chartData";
import { getIndicatorList } from "../../redux/slices/indicators";
import { fetchConfigs, selectConfig } from "../../redux/slices/heatMapConfigs";
import {
  StyledMainPage,
  MainPageSubContainer,
  TabsContainer,
} from "./MainPageStyle";
import HomeInterface from "../Home/HomeInterface/HomeInterface";
import SettingsInterface from "../Settings/SettingsInterface/SettingsInterface";
import { getChartCollections } from "../../redux/slices/chartCollections";
import DetectionPreview from "../DetectionPreview/DetectionPreview";
import useAuth from "../../auth/hooks/useAuth";

function MainChartPage() {
  const isAuth = useAuth();
  const dispatch = useDispatch();
  const { display, isInitialLoad } = useSelector(({ display }) => display);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    dispatch(getChartCollections(true));
  }, [dispatch]);

  //initial load
  useEffect(() => {
    dispatch(getModels({ keepSelectedModel: false }));
    dispatch(loadSavedCharts());

    if (isInitialLoad === true) {
      dispatch(selectConfig("6806385efa19f886d5ace0b2"));
    } else {
      dispatch(getIndicatorList());
      dispatch(fetchConfigs());
    }
  }, [dispatch, isInitialLoad]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <StyledMainPage>
      <Toolbar />
      <MainPageSubContainer>
        {isInitialLoad === false && (
          <ChartInterface
            show={
              display === "chart" ||
              display === "coldStart" ||
              display === "grid"
            }
          />
        )}
        {isAuth === false && (
          <TabsContainer>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="Trading Signals" />
              <Tab label="Search custom signals" />
            </Tabs>

            {activeTab === 0 && <HeatMapInterface />}
            {activeTab === 1 && <DetectionPreview />}
          </TabsContainer>
        )}
        {isAuth === true && display === "heatMap" && <HeatMapInterface />}
        {isAuth === true && display === "home" && <HomeInterface />}
        {isAuth === true && display === "settings" && <SettingsInterface />}
      </MainPageSubContainer>
    </StyledMainPage>
  );
}

export { MainChartPage as default };
